/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ToDoItem } from './ToDoItem';
import {
    ToDoItemFromJSON,
    ToDoItemFromJSONTyped,
    ToDoItemToJSON,
} from './ToDoItem';

/**
 * 
 * @export
 * @interface ClientDetails2
 */
export interface ClientDetails2 {
    /**
     * 
     * @type {string}
     * @memberof ClientDetails2
     */
    clientID: string;
    /**
     * 
     * @type {string}
     * @memberof ClientDetails2
     */
    clientFirstName: string;
    /**
     * 
     * @type {string}
     * @memberof ClientDetails2
     */
    clientInitial: string;
    /**
     * 
     * @type {string}
     * @memberof ClientDetails2
     */
    clientLastName: string;
    /**
     * 
     * @type {Array<ToDoItem>}
     * @memberof ClientDetails2
     */
    toDoItems: Array<ToDoItem>;
}

/**
 * Check if a given object implements the ClientDetails2 interface.
 */
export function instanceOfClientDetails2(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "clientID" in value;
    isInstance = isInstance && "clientFirstName" in value;
    isInstance = isInstance && "clientInitial" in value;
    isInstance = isInstance && "clientLastName" in value;
    isInstance = isInstance && "toDoItems" in value;

    return isInstance;
}

export function ClientDetails2FromJSON(json: any): ClientDetails2 {
    return ClientDetails2FromJSONTyped(json, false);
}

export function ClientDetails2FromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientDetails2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'clientID': json['ClientID'],
        'clientFirstName': json['ClientFirstName'],
        'clientInitial': json['ClientInitial'],
        'clientLastName': json['ClientLastName'],
        'toDoItems': ((json['ToDoItems'] as Array<any>).map(ToDoItemFromJSON)),
    };
}

export function ClientDetails2ToJSON(value?: ClientDetails2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ClientID': value.clientID,
        'ClientFirstName': value.clientFirstName,
        'ClientInitial': value.clientInitial,
        'ClientLastName': value.clientLastName,
        'ToDoItems': ((value.toDoItems as Array<any>).map(ToDoItemToJSON)),
    };
}

